/* eslint-disable prettier/prettier */
import React from 'react';

import { LandingHeaderWrapper } from './landingHeader.styled';
import Container from '../container/container.component';
import AWSLogo from '&assets/images/aws.png';
import SubmitButton from '../submitButton/submitButton.component';
import { useNavigate } from 'react-router-dom';
import LOGO from '&assets/images/AWS-Empty-6.jpg';
import { colors } from '&assets/constants/colors';

interface Props {
	children?: React.ReactNode;
	className?: string;
}

const LandingHeader = (props: Props) => {
	const { className } = props;
	const navigate = useNavigate();
	return (
		<LandingHeaderWrapper
			className={className ? className : ''}
			backgroundImage={LOGO}
		>
			<div className="content">
				<Container>
					<div className="header">
						<h1 className="title">GUST Innovation Hub</h1>
						<p className="sub-title">In collaboration with:</p>{' '}
						<img className="aws-logo" src={AWSLogo} alt=""></img>
						{/* <SubmitButton
							isWhite={true}
							className={'submit-header'}
							title="APPLY NOW"
							id="submit-a-challenge-landing"
							icon={true}
							handleClick={() => navigate('/submit-challenge')}
							iconColor={colors.primary}
						/> */}
					</div>
				</Container>
			</div>
		</LandingHeaderWrapper>
	);
};

export default LandingHeader;
